export const peopleAddress = [
    'people[].addresses[].street_line_1',
    'people[].addresses[].street_line_2',
    'people[].addresses[].equifax_token',
    'people[].addresses[].auto',
    'people[].addresses[].town',
    'people[].addresses[].postcode',
    'people[].addresses[].country',
    'people[].addresses[].uid',
    'people[].addresses[].house_name',
    'people[].addresses[].house_number',
    'people[].addresses[].residential_status',
    'people[].addresses[].extra_address'
];

export const peopleBirthday = [
    'people[].date_of_birth.dd',
    'people[].date_of_birth.mm',
    'people[].date_of_birth.yy'
];

export const peopleEmail = [
    'people[].email',
    'people[].emailUID',
    'people[].marketing_emails'
];

export const peopleFullName = ['people[].first_name', 'people[].last_name'];

export const peoplePhone = [
    'people[].phone[].uid',
    'people[].phone[].type',
    'people[].phone[].number'
];

export const commonPersonalInformationFields = [
    'people[].uid',
    'people[].title',
    'people[].roles',
    'people[].privacy_policy_agreement_date',
    ...peopleFullName,
    ...peopleAddress,
    ...peopleBirthday,
    ...peoplePhone,
    ...peopleEmail
];

export const limitedCompanyPersonalInformationFields =
    commonPersonalInformationFields;
